import { render, staticRenderFns } from "./gozareshGiri.vue?vue&type=template&id=b0c70046&scoped=true"
import script from "./gozareshGiri.vue?vue&type=script&lang=js"
export * from "./gozareshGiri.vue?vue&type=script&lang=js"
import style0 from "./gozareshGiri.vue?vue&type=style&index=0&id=b0c70046&prod&lang=css"
import style1 from "./gozareshGiri.vue?vue&type=style&index=1&id=b0c70046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c70046",
  null
  
)

export default component.exports